import { ICustomerRole } from "models/CustomerRole";
import { EnumUserType } from "models/User";

import { useSelector } from "react-redux";
import { RootState } from "store/ducks";


function isEmpty(obj: any) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

interface UserProps {
  customersRoles?: Array<ICustomerRole>;
  selectedCustomerId?: string;
}

interface CustomerProps {
  id?: string;
  useElectronicBillLading?: boolean;
}

export function useLoadCte() {

  const user = useSelector((state: RootState) => state.user);
  const customer = useSelector((state: RootState) => state.customer);

  let hasCte = false;
  let customerIds: Array<string | undefined> = [];

  if (user?.userType === EnumUserType.EMPLOYEE) {
    const dataTypeEmployee = validationUserTypeEmployee(customer);

    hasCte = dataTypeEmployee.hasCte;
    customerIds = dataTypeEmployee.customerIds;
  }

  if (user?.userType === EnumUserType.CUSTOMER) {
    const dataTypeCustomer = validationUserTypeCustomer(user);

    hasCte = dataTypeCustomer.hasCte;
    customerIds = dataTypeCustomer.customerIds;
  }

  return { hasCte, customerIds };
}

function validationUserTypeEmployee(customer: CustomerProps | undefined) {
  let loadCteTypeEmployee: boolean = true;

  if (customer) {
    let customerIdsTypeEmployee: Array<string | undefined> = [];

    if (customer?.useElectronicBillLading) {
      customerIdsTypeEmployee = [customer?.id];
    }

    if (!isEmpty(customer) && !customer?.useElectronicBillLading) {
      loadCteTypeEmployee = false;
    }

    return {
      hasCte: loadCteTypeEmployee,
      customerIds: customerIdsTypeEmployee
    };
  }

  return {
    hasCte: loadCteTypeEmployee,
    customerIds: []
  };
}

function validationUserTypeCustomer(user: UserProps) {
  let loadCteTypeCustomer: boolean = false;
  let customerIdsTypeCustomer: Array<string | undefined> = [];
  let customersWithCte = [];

  const findCustomer: any = user?.customersRoles?.filter((c: ICustomerRole) =>
    user?.selectedCustomerId?.includes(c.customerId!)
  );

  customersWithCte = findCustomer?.filter((c: any) =>
    c?.useElectronicBillLading
  );

  customerIdsTypeCustomer = customersWithCte.map((x: any) => {
    return x.customerId;
  });

  if (customerIdsTypeCustomer.length > 0) {
    loadCteTypeCustomer = true;
  }

  return {
    hasCte: loadCteTypeCustomer,
    customerIds: customerIdsTypeCustomer
  };
}
